import { css } from 'styled-components';
import {ConstBorderRound, ConstColor, ConstFontStyle} from "../../../../config/styles_const/styles_const";

export interface IBtnDefaultProps {
    icon?: string;
    widthSize?: "200px" | "100px";
}

export const mixinResetBtnCss = css`
    border: none;
    cursor: pointer;
    outline: none;
    appearance: none;
    vertical-align: middle;
    display: inline-block;
    flex-shrink: 0;
`;

export const mixinBtnSmall = css`
    height: 26px;
    font-style: normal;
    font-weight: ${ConstFontStyle.BtnSmall.fontWeight};
    font-size: ${ConstFontStyle.BtnSmall.fontSize};
    line-height: 26px;
    border-radius: ${ConstBorderRound.CornerRoundAll};
    padding: 0 20px;
`;

export const mixinBtnMiddle = css`
    height: 35px;
    font-style: normal;
    font-weight: ${ConstFontStyle.BtnMiddle.fontWeight};
    font-size: ${ConstFontStyle.BtnMiddle.fontSize};
    line-height: 35px;
    border-radius: ${ConstBorderRound.CornerRoundAll};
    padding: 0 20px;
`;

export const mixinBtnLarge = css`
    height: 50px;
    font-style: normal;
    font-weight: ${ConstFontStyle.BtnLarge.fontWeight};
    font-size: ${ConstFontStyle.BtnLarge.fontSize};
    line-height: 50px;
    border-radius: ${ConstBorderRound.CornerRoundAll};
    padding: 0 20px;
`;

export const mixinBtnCorporate = css`
    color: ${ConstColor.White};
    background-color: ${ConstColor.Corporate};
    // background: linear-gradient(104.57deg, #9A8C64 0%, #827654 100%);
    &:disabled {
        background-color: ${ConstColor.Gray};
        color: ${ConstColor.White};
        cursor: default;
    }
`;

export const mixinBtnCancel = css`
    color: ${ConstColor.Base};
    background-color: ${ConstColor.White};
    border: 1px solid ${ConstColor.Base};
`;

export const mixinBtnBorder = css`
    color: ${ConstColor.Corporate};
    background-color: ${ConstColor.White};
    border: 1px solid ${ConstColor.Corporate};
`;

export const mixinWithBtnPropsFn = (props: IBtnDefaultProps) => {
    return  (
        css`
            ${props.icon && `
                ::before {
                    content: ${props.icon};
                    font-family: "Font Awesome 5 Free";
                    font-weight: 900;
                }
            `}
            ${props.widthSize === "200px" && `
                width: ${props.widthSize};
            `}
             ${props.widthSize === "100px" && `
                width: ${props.widthSize};
            `}
    `)

};


// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_mixin.tsx